<template>
    <section>
        <legend v-if="order.table===null">Customer Details</legend>
        <legend v-else>POS Details</legend>
        <address>
            <div v-if="order.customerAddressesByCustomerAddressId">
                <strong >{{order.customerAddressesByCustomerAddressId.customersByCustomerId.name}}</strong><br />
                <span v-if="order.customerAddressesByCustomerAddressId.customersByCustomerId.email !== null" title="Email">Email: </span> <b>{{(order.customerAddressesByCustomerAddressId.customersByCustomerId.email ) ? order.customerAddressesByCustomerAddressId.customersByCustomerId.email : 'N/A'}}</b><br/>
                <span v-if="order.orderTypesByOrderTypeId.id===3">
                    Address: <b>{{order.customerAddressesByCustomerAddressId.address}}</b><br />
                    Area: <b>{{order.customerAddressesByCustomerAddressId.areasByAreaId.name}}</b><br />
                    City: <b >{{order.customerAddressesByCustomerAddressId.areasByAreaId.citiesByCityId.city}}</b><br />
                </span>
                <span v-else><b>Take Away Order</b></span>
                <div class="row">
                    <div class="col-md-4">
                        <abbr title="Phone">Phone-1:&nbsp;</abbr> <b>{{(order.customerAddressesByCustomerAddressId.customersByCustomerId.contact1 ) ? order.customerAddressesByCustomerAddressId.customersByCustomerId.contact1 : 'N/A'}}</b>
                    </div>
                    <div class="col-md-4">
                        <abbr title="Phone">Phone-2:&nbsp;</abbr> <b>{{(order.customerAddressesByCustomerAddressId.customersByCustomerId.contact2 ) ? order.customerAddressesByCustomerAddressId.customersByCustomerId.contact2 : 'N/A'}}</b>
                    </div>
                    <div class="col-md-4">
                        <abbr title="Phone">Phone-3:&nbsp;</abbr> <b>{{(order.customerAddressesByCustomerAddressId.customersByCustomerId.contact3 ) ? order.customerAddressesByCustomerAddressId.customersByCustomerId.contact3 : 'N/A'}}</b>
                    </div>
                </div>
            </div>
            <div v-else>
                <strong >{{order.dvmAddress.dvmCustomer.name}}</strong><br />
                <span title="Email">Email: </span> <b>{{(order.dvmAddress.dvmCustomer.email ) ? order.dvmAddress.dvmCustomer.email : 'N/A'}}</b><br/>
                <span v-if="order.orderTypesByOrderTypeId.id===3">
                    Address: <b>{{order.dvmAddress.address}}</b><br />
                    Area: <b>{{(order.dvmAddress.area !== "") ? order.dvmAddress.area : "N/A"}}</b><br />
                </span>
                <span v-else><b>Take Away Order</b></span>
                <div class="row">
                    <div class="col-md-4">
                        <abbr title="Phone">Contact Number:&nbsp;</abbr>
                      <b>
                        {{(order.dvmAddress.dvmCustomer.contactNumber ) ? order.dvmAddress.dvmCustomer.contactNumber : 'N/A'}}
                      </b>
                    </div>
                </div>
            </div>
        </address>  
      
    </section>
</template>

<script>
export default {
    name:"CustomerDetails",
    props:["order"],
    data (){
        return {

        }
    },
    watch: {
      order: function(){
        if(this.order.dvmAddress !== null && this.order.dvmAddress.dvmCustomer.deleted){
          let contactNo = this.order.dvmAddress.dvmCustomer.contactNumber;
          this.order.dvmAddress.dvmCustomer.contactNumber = contactNo.split("&")[0];
        }
      }
    }
}
</script>